<div class="accordion-convergence -main">
  <div class="row">
    <div class="col-sm-12">
      <div class="d-md-flex justify-content-between">
        <div>
          <icon (click)="changeExpandState()" [name]="icon" class="-round -floatLeft accordion-convergence -icon">
          </icon>
          <h4 class="accordion-convergence -title">{{ title }}</h4>
        </div>
        <div>
          <h5 class="accordion-convergence -date">{{ date }}</h5>
        </div>
      </div>
    </div>
    @if (subtitle) {
    <div class="col-sm-12">
      <p class="accordion-convergence -subtitle">{{ subtitle }}</p>
    </div>
    }
  </div>

  <div class="row accordion-convergence -hiddenRow" [@closed]="closed">
    <div class="col-sm-12">
      <div class="accordion-convergence -hiddenContent">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</div>
